module.exports = __webpack_public_path__ + "static/media/robot_stage.023b8cfa.jpg";